// extracted by mini-css-extract-plugin
export default {"textRight":"Tooltip_textRight__VHKTj"};